import { Component, OnInit } from '@angular/core';
import {PageService} from "../../services/page.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';


@Component({
  selector: 'app-culturalcouncil',
  templateUrl: './culturalcouncil.component.html',
  styleUrls: ['./culturalcouncil.component.css', '../main.style.css','mobile.style.css']
})
export class culturalcouncilComponent implements OnInit {

  mobile:boolean = false;

  opened = 'true';

  theIcon = 'fa-bars';

  theOpen:boolean = false;

  changeIcon(){
    this.theOpen = this.theOpen ? false : true;
    this.theIcon = this.theOpen ? 'fa-close' : 'fa-bars';
  }

  constructor(private pService:PageService,private route: ActivatedRoute,
      private router: Router,  breakpointObserver: BreakpointObserver) {
      
      breakpointObserver.observe([
        Breakpoints.HandsetLandscape,
        Breakpoints.HandsetPortrait
      ]).subscribe(result => {
        if (result.matches) {
          this.mobile = true;
        }
      });
   }


  isLoaded:boolean = false;

  menu:any;
  menuArray = [];

  aboutUrl:any;

  pageContent:any;
  pageTitle:any;

  ngOnInit() {
    if(this.mobile){
      this.opened = 'false';
    }
  	this.pService.getculturalcouncilMenu().subscribe((result:any)=>{
  		this.menu = result;
      console.log(result);
  		for(let key in this.menu){
  			let str = {'key':key,'value':this.menu[key]};
  			this.menuArray.push(str);
  		}
  	})

    this.aboutUrl = this.route.snapshot.paramMap.get('pid');
    this.pService.getculturalcouncilPage(this.aboutUrl).subscribe((result:any)=>{
      this.pageTitle = this.menu[this.aboutUrl];
      this.pageContent = result;
      this.isLoaded = true;
    })
  	this.route.params.subscribe( params => {
      this.isLoaded=false;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      
      this.pService.getculturalcouncilPage(params.pid).subscribe((result:any)=>{
        this.pageTitle = this.menu[params.pid];
      	this.pageContent = result;
        this.isLoaded = true;
      })
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/culturalcouncil/culturalcouncil.component.ts